import styled from 'styled-components';
import colors from '../../assets/styles/colors';

export const SimulationsContainer = styled.div`
  min-height: 100%;
  position: relative;
  background: ${colors.bgScreen};
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 44px 20px 15px 20px;

  .pagination {
    margin-top: 40px;
    margin-bottom: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    list-style: none;

    li {
      margin-left: 30px;
      cursor: pointer;
      
      &:first-child {
        margin: 0;
      }

      a {
        color: ${colors.bgPrimary};
        font-size: 16px;
        display: flex;
        align-items: center;
        font-family: 'Montserrat', sans-serif;
      }

      &.active {
        a {
          font-weight: 700;
        }
      }

      &.disabled {
        svg {
          color: ${colors.grayLight};
        }
      }
    }
  }
`;

export const SimulationsWrapper = styled.div``;

export const SimulationsHeader = styled.div``;

export const SimulationsHaderTitle = styled.small`
  font-size: 12px;
  color:${colors.textSecondary};
  text-transform: uppercase;
`;

export const FadeContainer = styled.div`
  transition: ease-in-out .1s;
  opacity: ${prop => prop.fade ? '1' : '0'};
`;

export const SimulationsEmptyStateContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  padding-top: 40px;
`;

export const SimulationsEmptyStateParagraph = styled.p`
  font-weight: 600;
  font-size: 17px;
  line-height: 21px;
  color: ${colors.bgPrimary};
  margin-top: 20px;
`;
